module.exports = __webpack_public_path__ + "img/xmasParty15.e5ac2887.jpg";